import { __ } from '../../../locales'

const ErrorValidation = ({ style, text = __('inputs.global.error_message') }) => {
    return (
        <div style={style} className={'input-error mt-2'}>
            {text}
        </div>
    );
};

export default ErrorValidation
